<template>
    <div class="c_indexBox">
        <div class="c_indexBox_child">
            <div v-if="active==6" class="rosTitBox">App Account</div>
            <div v-else class="rosTitBox">Roster & Labour</div>
            <div class="ros_selBox">
                <!-- <span v-if="isPro" class="ros_checkTit" @click="changeType(1)">Roster
                    <span class="ros_line" :class="{'active':active==1}"></span>
                </span> -->
                <template v-if="active !== 6">
                  <span class="ros_checkTit" @click="changeType(2)">Labour History
                      <span class="ros_line" :class="{'active':active==2}"></span>
                  </span>
                  <span v-if="deputyFlag" class="ros_checkTit" @click="changeType(3)">Deputy Area
                      <span class="ros_line" :class="{'active':active==3}"></span>
                  </span>
                  <span v-if="tandaFlag" class="ros_checkTit" @click="changeType(5)">Tanda Area
                      <span class="ros_line" :class="{'active':active==5}"></span>
                  </span>
                  <span v-if="!tandaFlag" class="ros_checkTit" @click="changeType(4)">Salary Employee
                      <span class="ros_line" :class="{'active':active==4}"></span>
                  </span>

                  <!-- <span class="ros_checkTit" @click="changeType(6)">App Account
                      <span class="ros_line" :class="{'active':active==6}"></span>
                  </span> -->
                </template>


                <!--<span class="ros_checkTit" @click="changeType(3)">Employee List
                    <span class="ros_line" :class="{'active':active==3}"></span>
                </span>
                <div class="date" v-if="active==1">
                    <el-date-picker
                    v-model="time"
                    type="daterange"
                    :range-separator="separator"
                    :picker-options="pickerOptions"
                    :editable="false"
                    :clearable="true"
                    format="dd/MM/yyyy"
                    @change="changeTime">
                    </el-date-picker>
                </div>-->
                <div class="extra_btn" v-if="active==3 && companyId === '' && !nodata" @click="areaEdit" style="margin-right:0">Edit</div>
                <div class="extra_btn" v-if="active==5 && companyId === '' && !nodata" @click="areaTandaEdit" style="margin-right:0">Edit</div>
                <div class="extra_btn" v-if="active==3 && companyId !== '' && !nodata" @click="saveOperate" style="margin-right:0">Save</div>
                <div class="extra_btn" v-if="active==5 && companyId !== '' && !nodata" @click="saveOperate" style="margin-right:0">Save</div>
                <div class="extra_btn" v-if="active==3 && companyId == '' && nodata" @click="areaEdit" style="margin-right:0">Set</div>
                <div class="extra_btn" v-if="isPro && active==4" @click="openAddNewEmployee" style="margin-right:0">Add new salary employee</div>
                <div class="extra_btn" v-if="active==6" @click="showAddDio" style="margin-right:0">Add new app account</div>
            </div>
        </div>
        <router-view :timeToSave="timeToSave" :areaId="companyId" :time="time" :addFlag='addFlag' :isPro="isPro" :isDoneLoad="isDoneLoad"
        @close='closeDio' @open='showAddDio' @addSuccess='addSuccess' @save="updateInfo" @noData="nodata = true" />

      <el-dialog
      title=""
      :visible.sync="areaChoose"
      :modal-append-to-body="false"
      :show-close='false'
      class="posDio"
      :close-on-click-modal='true'
      width="840px"
      top="230px"
      center>
            <div class="area-dialog">
                <h1>Found that this account has multiple physical addresses.</h1>
                <h2>Please select the roster of the physical address you want to obtain.</h2>
                <div class="bind" v-for="(item, index) in areaChooseList" :key="index"
                @click="selectArea(item.companyId, item.companyName)">{{item.companyName}}<i class="el-icon-arrow-right"></i></div>
            </div>
      </el-dialog>

    <pin-dialog :visible="visible" @receive="receiveEvents" />

    </div>
</template>

<script>
import api from '../../api/api';
import pinDialog from '../common/pin'

export default {
    data() {
        return {
            venueType: sessionStorage.getItem('venueType'),
            show_time:'',
            time:[],
            active:1,
            addFlag:false,
            separator:'',
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() > Date.now()
                }
            },

            areaChoose: false,
            areaChooseList: [],
            companyId: '',
            companyName: '',
            timeToSave: false,
            nodata: false,

            visible: false,

            deputyFlag: false,
            tandaFlag: false,
            openType: '',
            isPro: false,
            isDoneLoad: false
        }
    },
    methods: {
        proCallback(res) {
            if (res.data.code == 0){
                this.deputyFlag = res.data.data.deputyFlag;
                this.tandaFlag = res.data.data.tandaFlag;
            } else if (res.data.code == 8902) {
                sessionStorage.clear();
                this.$router.push("/login");
            } else {
                Utils.alert("", res.data.message, "error");
            }
        },
        receiveEvents(type) {
            this.visible = false
            if (type === 'confirm') {
                if (this.openType == 'add') {
                    this.showAddDio()
                } else {
                    this.$router.push({name:'employee',params:{auth: 1}})
                }
            }
        },
        saveOperate () {
            this.timeToSave = true
        },
        updateInfo(list) {
            this.timeToSave = false
            let temp = []
            list.forEach(item => {
                temp.push({
                    Company: item.Company,
                    CompanyName: item.CompanyName,
                    Id: item.Id,
                    LabelWithCompany: item.LabelWithCompany,
                    OperationalUnitName: item.OperationalUnitName
                })
            })
            if (this.active === 3)
                api.saveInfo({
                    params: {
                        companyId: this.companyId,
                        companyName: this.companyName,
                        operationalUnitInfoList: temp
                    },
                    callback: (res) => {
                        if (res.data.code === 0) {
                            this.companyId = ''
                            this.companyName = ''
                        } else {
                            Utils.alert('', res.data.message, 'error')
                        }
                    }
                })
            else
                api.saveTandaInfo({
                    params: {
                        companyId: this.companyId,
                        companyName: this.companyName,
                        operationalUnitInfoList: temp
                    },
                    callback: (res) => {
                        if (res.data.code === 0) {
                            this.companyId = ''
                            this.companyName = ''
                        } else {
                            Utils.alert('', res.data.message, 'error')
                        }
                    }
                })
        },
        selectArea (id, name) {
            this.companyId = id
            this.companyName = name
            this.areaChoose = false
        },
        areaEdit () {
            this.areaChoose = true
            api.venueInfo({
                callback: (res) => {
                    if (res.data.code === 0) {
                        this.areaChooseList = res.data.data
                    } else {
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
        },
        areaTandaEdit () {
            this.areaChoose = true
            api.venueTandaInfo({
                callback: (res) => {
                    if (res.data.code === 0) {
                        this.areaChooseList = res.data.data
                    } else {
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
        },
        showAddDio(){
            this.addFlag = true
        },
        openAddNewEmployee() {
            var pinStatus = sessionStorage.getItem('pinstatus')
            var isPinNeeded = sessionStorage.getItem('isPinNeeded')
            this.openType = 'add'
            if (pinStatus == 'true' && isPinNeeded == '1') {
                this.visible = true
            } else {
                this.showAddDio()
            }
        },
        closeDio(){
            this.addFlag = false
        },
        addSuccess(){
            this.$emit('addSuccess')
        },
        changeType(key){
            // console.log(`key`)
            // console.log(key)
            this.active=key
            // console.log(`this.active`)
            // console.log(this.active)
            this.time=[]
            this.show_time=''
            this.companyId = ''
            this.companyName = ''
            this.nodata = false
            if(key==1){
                this.$router.push({path:'/rosterAndlabourroster'})
            }else if(key == 2){
                this.$router.push({path:'/rosterAndlabourlabour'})
            }else if(key == 3){
                this.$router.push({path:'/rosterAndlabourarea'})
            }else if(key == 4){
                if (this.venueType === '2')
                    this.visible = true
                else if (this.venueType === '1')
                    this.$router.push({path:'/rosterAndemployee'})
            }else if(key == 5){
                this.$router.push({path:'/rosterAndtandaarea'})
            }else if(key == 6){
                this.$router.push({path:'/rosterAndapp'})
            }
            this.closeDio()
        },
        changeTime(){ //切换时间
            if(this.time!=null&&this.time.length){
                this.separator = '-'
                let pat={
                    startTime:this.time[0].getTime(),
                    endTime:this.time[1].getTime() + 86400000 - 1,
                }
            }else{
                this.separator = ''
            }
        },
        getActiveKey(){
            const routerName = this.$route.name
            if (routerName=='roster')
                this.active=1
            else if (routerName=='labour')
                this.active=2
            else if (routerName == 'employee')
                this.active=4
            else if (routerName=='area')
                this.active=3
            else if (routerName=='rosterAndapp')
                this.active=6
            else if (routerName=='tandaArea')
                this.active=5
            // console.log('this.active')
            // console.log(this.$route)
        }
    },
    components: {
        pinDialog
    },
    beforeUpdate() {
        this.getActiveKey()
    },
    mounted() {
        this.getActiveKey()
        api.progress(
            '',
            this.proCallback
        );

        this.$root.$on('isPro', (isPro) => {
            this.isPro = isPro
            this.isDoneLoad = true
        })
    },

    watch: {
    }
}
</script>

<style lang="scss" scoped>
@import 'static/scss/scrollbar';
.area-dialog{
    overflow-y: auto !important;
    max-height: 600px !important;

    &::-webkit-scrollbar {
        @extend .scrollbar;
    }

    &::-webkit-scrollbar-track {
        @extend .scrollbar-track-transparent;
    }

    &::-webkit-scrollbar-thumb {
        @extend .scrollbar-thumb-dark;
    }

    h1{
        margin-bottom: 10px;
        word-break: break-word;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-color);
        line-height: 33px;
    }
    h2{
        margin-bottom: 20px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        word-break: break-word;
        color: var(--text-color);
    }
    .bind{
      width: 100%;
      background:rgba(21,28,39,1);
      border-top: 1px solid #5F5F5F;
      border-bottom: 1px solid #5F5F5F;
      box-sizing: border-box;
      padding: 9px 20px;
      line-height: 32px;
      font-size: 20px;
      color: var(--text-color);
      cursor: pointer;
      i{
        float: right;
        padding-top: 9px;
      }
    }
}
.c_indexBox{
    width: 100%;
    position: relative;
    min-width: 1100px;
    .c_indexBox_child{
        width: calc(100%);
        z-index: 100;
        background-color: var(--background-color);
    }
    .rosTitBox{
        height:33px;
        font-size:24px;
        font-weight:600;
        color:var(--text-color);
        line-height:33px;
        margin-bottom: 39px;
    }
    .ros_selBox{
        display: flex;
        margin-bottom: 30px;
        position: relative;
        .ros_checkTit{
            cursor: pointer;
            height:28px;
            font-size:20px;
            font-weight:600;
            color:var(--text-color);
            line-height:28px;
            position: relative;
            margin-right: 44px;
        }
        .timepick_showBox{
            width: 255px;
            border-bottom: 2px solid var(--text-color);
            background-color: var(--background-color);
            height: 40px;
            align-items: center;
            display: flex;
            position: absolute;
            right: 60px;
            color: var(--text-color);
            cursor: pointer;
            .time_icon_pick{
                position: absolute;
                right: 3px;
                width: 22px;
                height: 22px;
                background: url('../../../static/img/time.png');
                background-size: contain;
            }
        }
        .myTimeBox{
            cursor: pointer;
            position: absolute;
            opacity: 0;
            z-index: 10;
            width: 255px;
            right: 60px;
        }
    }
    .ros_line{
        position: absolute;
        width: 0px;
        right: 0;
        bottom: -13px;
        height: 2px;
        border-radius: 3px;
        overflow: hidden;
        transition: all .7s;
        opacity: 0.1;
    }
    .active{
        left: 0;
        width:100%;
        background:rgba(234,55,150,1);
        opacity: 1;
        // position: relative;
        // &::after{
        //     content: '';
        //     position: absolute;
        //     left: 0;
        //     bottom: -13px;
        //     width:131px;
        //     height:2px;
        //     background:rgba(234,55,150,1);
        // }
    }

    .extra_btn{
        width:360px;
        height:60px;
        font-size:26px;
        font-weight:600;
        color:var(--primary-color);
        line-height:60px;
        text-align: center;
        border: 1px solid var(--primary-color);
        cursor: pointer;
        margin-left: auto;
        margin-right: 60px;
    }
}
.fade-in-enter-active, .fade-in-leave-active {
    transition: opacity .2s ease;
}
.fade-in-enter, .fade-in-leave-to {
    opacity: 0;
}
label > * {
    pointer-events: none;
}
.date{
    margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/rosterAndLabour/index.vue